import React from "react";
import classes from "./PageNotFound.module.css";

const PageNotFound = () => {
  return (
    <div className={classes["notfound"]}>
      <div className={classes["notfound-content"]}>404</div>
      <div className={classes["notfound-sub-content"]}>
        Oops! Page Not Found
      </div>
    </div>
  );
};

export default PageNotFound;
